<template>
	<div>
		<v-slide-x-transition :hide-on-leave="true">
			<div v-if="step === 1">
				<v-row class="justify-center">
					<v-col cols="12" md="6">
						<v-form @submit.prevent="initialCheck">
							<div class="mb-2">ابتدا کد ملی مشتری مورد نظر را وارد کنید:</div>
							<v-text-field class="mb-4" ref="nationalCode" v-model="nationalCode" maxlength="10" label="کد ملی*" :error-messages="errorMessages" :rules="[() => !!nationalCode || 'کد ملی را وارد کنید']" required />
							<v-alert class="mb-2" type="success" outlined v-if="localData && localData.id === 0">مشتری با کد ملی {{ localData.nationalCode }} قبلا در سیستم ثبت نشده است.</v-alert>
							<v-alert class="mb-2 mt-2" type="error" outlined v-if="localData && localData.id !== 0">کد ملی {{ localData.nationalCode }} با نام {{ localData.fullName }} قبلا در سیستم ثبت شده است.</v-alert>
							<v-slide-x-transition :hide-on-leave="true">
								<v-btn color="primary" v-if="!localData || localData.id !== 0" dark @click="initialCheck" :loading="loading" block>
									بررسی اولیه
								</v-btn>
							</v-slide-x-transition>
							<v-slide-x-transition :hide-on-leave="true">
								<v-btn color="blue" v-if="localData && localData.id === 0" dark @click="step = 2" block>
									ثبت مشتری
								</v-btn>
							</v-slide-x-transition>
							<v-slide-x-transition :hide-on-leave="true">
								<v-btn class="mt-2" color="blue" v-if="localData && localData.id !== 0" dark @click="newLoanRequest" block>
									ثبت درخواست وام جدید
								</v-btn>
							</v-slide-x-transition>
						</v-form>
					</v-col>
				</v-row>
			</div>
		</v-slide-x-transition>
		<v-slide-x-transition :hide-on-leave="true">
			<v-form v-if="step === 2 && localData" ref="form" class="mx-2" lazy-validation @submit.prevent="submit">
				<v-row>
					<v-col cols="12" md="4">
						<v-text-field ref="username" v-model="localData.userName" label="نام کاربری:" hint="نام کاربری به صورت خودکار پر می شود" persistent-hint disabled />
					</v-col>
					<v-col cols="12" md="4">
						<v-text-field ref="nationalCode" v-model="localData.nationalCode" maxlength="10" label="کد ملی:" :error-messages="errorMessages" :rules="[() => !!localData.nationalCode || 'کد ملی را وارد کنید']" hint="از صحت کد ملی مطمئن شوید" persistent-hint required disabled />
					</v-col>
					<v-col cols="12" md="4" class="pt-2">
						<div>
							<small class="mb-1">تاریخ عضویت:</small>
							<date-picker ref="regDate2" v-model="localData.regDate2" format="YYYY-MM-DDTHH:mm:ss" display-format="dddd jDD jMMMM jYYYY" :error-messages="errorMessages" clearable auto-submit :rules="[() => localData.regDate2 === '' || 'تاریخ عضویت را به صورت صحیح وارد کنید']" />
							<div class="red--text">
								{{ datePickerValidatioin }}
							</div>
						</div>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" md="4" class="py-0">
						<v-text-field ref="firstName" v-model="localData.firstName" label="نام*" :error-messages="errorMessages" :rules="[() => !!localData.firstName || 'نام را وارد کنید']" required />
					</v-col>
					<v-col cols="12" md="4" class="py-0">
						<v-text-field ref="lastName" v-model="localData.lastName" label="نام خانوادگی*" :error-messages="errorMessages" :rules="[() => !!localData.lastName || 'نام خانوادگی را وارد کنید']" required />
					</v-col>
					<v-col cols="12" md="4" class="py-0">
						<v-text-field ref="fatherName" v-model="localData.fatherName" label="نام پدر*" :error-messages="errorMessages" :rules="[() => !!localData.fatherName || 'نام پدر را وارد کنید']" required />
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" md="8" class="py-0">
						<v-card color="#eee" class="px-2 d-flex">
							<v-text-field ref="mobile" v-model="localData.mobile" maxlength="11" label="موبایل*" />
							<div v-if="!localData.mobileVerified || initMobile !== localData.mobile" class="d-flex px-2 align-center" style="width:170px">
								<v-text-field v-model="localData.mobileOtp" maxlength="5" label="کد تایید" />
								<v-btn v-if="sendCodeVisible" small class="mr-2" @click="sendOTP" :loading="optLoading"><small>ارسال کد</small></v-btn>
								<Countdown class="black--text fs-h3" @finish="countDownFinished" ref="countdown" />
							</div>
							<div class="px-2 align-center d-flex" v-else>
								<v-icon small color="success">mdi-check-circle</v-icon>
								<small class="success--text">تایید شده</small>
							</div>
						</v-card>
					</v-col>
					<v-col cols="12" md="4" class="py-0">
						<v-text-field ref="phone" v-model="localData.phone" maxlength="20" label="تلفن ثابت" />
					</v-col>

				</v-row>
				<v-row>

				</v-row>
				<v-row>
					<v-col cols="12" md="2">
						<v-text-field ref="city" v-model="localData.city" label="شهر*" :rules="[() => !!localData.city || 'شهر را وارد کنید']" required />
					</v-col>
					<v-col cols="12" md="8">
						<v-text-field ref="address" v-model="localData.address" label="آدرس*" :rules="[() => !!localData.address || 'آدرس را وارد کنید', () => !localData.address || localData.address.length >= 20 || 'طول کاراکترهای آدرس باید حداقل 20 کاراکتر باشد']" required />
					</v-col>
					<v-col cols="12" md="2">
						<v-text-field ref="postalCode" v-model="localData.postalCode" maxlength="10" label="کد پستی*" :error-messages="errorMessages" :rules="[() => !!localData.postalCode || 'کد پستی را وارد کنید']" required />
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" md="12" class="py-0">
						<div style="border-radius: 5px;background:#eee;padding: 10px;">
							<div class="text-center secondary--text mb-2">شماره حساب ها</div>
							<v-card v-for="(item, index) in bankAccounts" :key="index" class="mb-3 pa-3" elevation="0" style="border: 1px solid #dca6e5">
								<v-row>
									<v-col cols="12" md="5" class="py-0 my-0">
										<v-text-field v-model="item.accountNumber" maxlength="16" label="شماره کارت*" :error-messages="errorMessages" :rules="[(val) => !!val || 'شماره حساب را وارد کنید', (val) => !!val && val.length === 16 || 'شماره کارت باید 16 رقم باشد']" required />
									</v-col>
									<v-col cols="12" md="3" class="py-0 my-0">
										<v-text-field v-model="item.bank" label="بانک*" :error-messages="errorMessages" :rules="[(val) => !!val || 'نام بانک را وارد کنید']" required />
									</v-col>
									<v-col cols="12" md="3" class="py-0 my-0">
										<v-text-field v-model="item.branch" label="شعبه*" :error-messages="errorMessages" :rules="[(val) => !!val || 'شعبه را وارد کنید']" required />
									</v-col>
									<v-col cols="1" md="1" class="my-0 py-0 d-flex flex-column justify-center">
										<v-btn @click="removeBankAccount(item, index)" class="" x-small icon dark color="pink" title="حذف">
											<v-icon dark>
												mdi-trash-can-outline
											</v-icon>
										</v-btn>
									</v-col>
								</v-row>
							</v-card>
							<div class="text-center mt-5">
								<v-btn class="mx-auto" color="secondary" dark @click="addBankAccount" small>
									<v-icon dark>
										mdi-plus-circle-outline
									</v-icon>
									شماره حساب جدید
								</v-btn>
							</div>
						</div>
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" class="py-0 mt-2">
						<h2 class="py-0">معرف 1</h2>
					</v-col>
					<v-col cols="12" md="4" class="py-0">
						<v-text-field ref="familiar1FirstName" class="pt-1" v-model="localData.familiar1FirstName" label="نام" maxlength="50" :error-messages="errorMessages" />
					</v-col>
					<v-col cols="12" md="4" class="py-0">
						<v-text-field ref="familiar1LastName" class="pt-1" v-model="localData.familiar1LastName" label="نام خانوادگی" maxlength="50" :error-messages="errorMessages" />
					</v-col>
					<v-col cols="12" md="4" class="py-0">
						<v-text-field ref="familiar1Mobile" class="pt-1" v-model="localData.familiar1Mobile" label="شماره تماس" maxlength="20" :error-messages="errorMessages" />
					</v-col>
				</v-row>
				<v-row>
					<v-col cols="12" class="py-0 mt-2">
						<h2 class="py-0">معرف 2</h2>
					</v-col>
					<v-col cols="12" md="4" class="py-0">
						<v-text-field ref="familiar2FirstName" class="pt-1" v-model="localData.familiar2FirstName" label="نام" maxlength="50" :error-messages="errorMessages" />
					</v-col>
					<v-col cols="12" md="4" class="py-0">
						<v-text-field ref="familiar2LastName" class="pt-1" v-model="localData.familiar2LastName" label="نام خانوادگی" maxlength="50" :error-messages="errorMessages" />
					</v-col>
					<v-col cols="12" md="4" class="py-0">
						<v-text-field ref="familiar2Mobile" class="pt-1" v-model="localData.familiar2Mobile" label="شماره تماس" maxlength="20" :error-messages="errorMessages" />
					</v-col>
				</v-row>
				<!-- <v-row>
									<v-col cols="12" md="6" class="py-0">
										<v-text-field v-model="localData.password" :rules="[() => !!localData.password || 'کلمه عبور را وارد کنید']" :error-messages="errorMessages" :type="'password'" name="password" label="کلمه عبور*" hint="حداقل 8 کاراکتر" />
									</v-col>
									<v-col cols="12" md="6" class="py-0">
										<v-text-field v-model="localData.confirmPassword" :rules="[() => localData.confirmPassword === localData.password || 'تکرار کلمه عبور با کلمه عبور مطابقت ندارد']" :error-messages="errorMessages" :type="'password'" name="confirmPassword" label="تکرار کلمه عبور*" />
									</v-col>
								</v-row> -->
				<small>*فیلدهای ستاره دار ضروری هستند.</small>
				<v-card-actions>
					<v-btn v-if="localData.id !== 0" color="secondary" dark @click="iranValidityDialog = true">
						مشاهده اعتبارسنجی
					</v-btn>
					<v-spacer />
					<v-btn @click="$emit('callbck', false)">
						بستن
					</v-btn>
					<v-btn color="blue" dark type="submit" :loading="loading">
						ذخیره
					</v-btn>
				</v-card-actions>
			</v-form>
		</v-slide-x-transition>

		<v-dialog v-model="dialogLoanRequest" scrollable persistent max-width="1000px">
			<v-card>
				<v-card-title>
					<span class="headline">درخواست وام ({{ localData ? localData.fullName : '' }})</span>
					<v-spacer />
					<v-btn @click="dialogLoanRequest = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<modify-request ref="modifyRequest" v-if="dialogLoanRequest" :data="selectedRequest" :user="localData" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-dialog v-model="iranValidityDialog" max-width="800px">
			<v-card>
				<v-card-title>
					<div><span class="headline">اعتبارسنجی ها</span></div>
					<v-spacer />
					<v-btn @click="iranValidityDialog = false" icon>
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-container>
						<IranValidityManager :isAgent="true" v-if="iranValidityDialog" :userId="localData.id" :isSummery="false" />
					</v-container>
				</v-card-text>
			</v-card>
		</v-dialog>

	</div>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'
	import { emptyId } from '@/util/emptyId'
	import { call, get } from 'vuex-pathify'
	import VuePersianDatetimePicker from 'vue-persian-datetime-picker'

	export default {
		name: 'ModifyMember',
		components: {
			'date-picker': VuePersianDatetimePicker,
			'modify-request': () => import('./ModifyLoanRequest.vue'),
			IranValidityManager: () => import('@/components/IranValidityManager'),
			Countdown: () => import('@/components/Countdown'),
		},
		props: {
			data: { type: Object },
			fromLoanRequest: { type: Boolean },
		},
		data() {
			return {
				errorMessages: '',
				iranValidityDialog: false,
				localData: null,
				nationalCode: '',
				datePickerValidatioin: '',
				loading: false,
				optLoading: false,
				step: 1,
				dialogLoanRequest: false,
				selectedRequest: { id: emptyId },
				bankAccounts: [],
				sendCodeVisible: true,
				initMobile: ''
			}
		},
		mounted() {
			if (this.data?.id !== 0) {
				this.step = 2
				this.prepareData()
			}
		},
		computed: {
			isSuperAdmin: get('auth/isSuperAdmin')
		},
		methods: {
			countDownFinished() {
				this.sendCodeVisible = true
			},
			submit() {
				this.datePickerValidatioin = ''
				if (this.localData.regDate2 === '') {
					this.datePickerValidatioin = 'تاریخ را وارد کنید'
					return
				}
				if (!this.$refs.form.validate()) { return }
				if (!this.bankAccounts.length) {
					toast.error('ثبت حداقل یک شماره حساب الزامی است')
					return
				}
				let data = {}
				data = Object.assign(data, this.localData)
				data.bankAccountsJson = JSON.stringify(this.bankAccounts)
				this.loading = true
				api.post('agent/customer/' + (this.localData.id === 0 ? 'create' : 'edit'), data)
					.then(response => {
						toast.success('اطلاعات با موفقیت ذخیره شد.')
						// this.$emit('callbck', true)
						if (this.localData.id === 0) {
							this.localData.id = response
							this.dialogLoanRequest = true
						}
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.loading = false
					})
			},
			sendOTP() {
				if (!this.localData.mobile) {
					toast.error('شماره موبایل وارد نشده است')
					return
				}
				this.optLoading = true
				api.post('account/SendOTP/' + this.localData.mobile, {})
					.then(response => {
						this.sendCodeVisible = false
						this.$refs.countdown.start()
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => {
						this.optLoading = false
					})
			},
			prepareData() {
				if (!this.data) {
					this.data = { id: 0 }
				}
				if (!this.data.id) {
					this.data.id = 0
				}
				api.get('agent/customer/get/' + this.data.id, null)
					.then(
						response => {
							this.localData = response
							this.initMobile = this.localData.mobile
							if (this.data.id === 0) Object.assign(this.localData, this.data)
							if (this.localData.regDate2 === '0001-01-01T00:00:00') { this.localData.regDate2 = '' }
							this.bankAccounts = this.localData.bankAccountsJson ? JSON.parse(this.localData.bankAccountsJson) : []
						})
					.catch(err => {
						toast.error(err.message)
					})
			},
			initialCheck() {
				if (!this.nationalCode) {
					toast.error('ابتدا کد ملی مشتری را وارد کنید')
					return
				}
				this.localData = null
				this.loading = true
				api.get('agent/customer/getByNationalCode/' + this.nationalCode, null)
					.then(
						response => {
							this.localData = response
							this.localData.nationalCode = this.nationalCode
							this.initMobile = this.localData.mobile
							if (this.localData.id === 0) this.localData.userName = '***'
							if (this.localData.regDate2 === '0001-01-01T00:00:00') { this.localData.regDate2 = new Date().toJSON() }
							if (this.fromLoanRequest && this.localData.id !== 0) {
								this.localData = response
								this.newLoanRequest()
							}
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(() => this.loading = false)
			},
			newLoanRequest() {
				if (!this.localData) {
					toast.error('مشتری یافت نشد.')
					return
				}
				this.dialogLoanRequest = true
			},
			removeBankAccount(item, index) {
				this.bankAccounts.splice(index, 1)
			},
			addBankAccount() {
				let newItem = {
					accountNumber: '',
					bank: '',
					branch: '',
				}
				this.bankAccounts.push(newItem)
			},
		},
	}
</script>
<style></style>
